import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import CheckboxField from 'components/form/checkbox'
import FilterListManagement from './filter-list-management'
import './configure-filtering.css'

const ConfigureFiltering = ({ enableBlastFiltering, widgetId }) => (
  <div className='br-filtering form-group darkPanel'>
    <div className='col-md-12'>
      <div className='portlet light'>
        <div className='portlet-title'>
          <div className='caption'>
            <i className='fa fa-filter font-green-haze hidden-xs' />
            <span className='caption-subject bold font-green-haze uppercase'>
              Filtering
            </span>
          </div>
        </div>

        <div className='portlet-body'>
          <div className='br-filtering-options row'>
            <div className='col-md-12'>
              <Field
                id='brt-experience-moderation'
                name='hideInteractionWhenFlagged'
                component={CheckboxField}
                label='Hide Tweet Replies with inappropriate language or content in the users reply copy, full name, handle, bio or location'
                className='icheckbox_square'
              />
              <Field
                id='brt-experience-moderation'
                name='enableFiltering'
                component={CheckboxField}
                label="Exclude Tweets with inappropriate language in the user's tweet copy, full name, handle, bio or location"
                className='icheckbox_square'
              />
            </div>
            <div className='col-md-12'>
              <Field
                id='brt-experience-moderation'
                name='enableBlastFiltering'
                component={CheckboxField}
                label="Verify that User's @handles are appropriate before sending out the blast"
                className='icheckbox_square'
              />
            </div>
            {!enableBlastFiltering && (
              <div className='col-md-12'>
                <div className='br-filter-error'>
                  <i className='fa fa-exclamation-triangle' />
                  <div className='br-filter-error-text'>
                    <span>Caution: </span> Unchecking this option may result in
                    contravening Twitter policy
                  </div>
                </div>
              </div>
            )}
          </div>
          <hr />
          <FilterListManagement widgetId={widgetId} />
        </div>
      </div>
    </div>
  </div>
)

ConfigureFiltering.propTypes = {
  enableBlastFiltering: PropTypes.bool,
  widgetId: PropTypes.string
}

export default ConfigureFiltering



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-filtering/configure-filtering.js